// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1nL7S","search":"Settings_search__10UZ1","filter":"Settings_filter__3Gzg4"};